export const USERS = 'users';
export const QUOTES = 'quotes';
export const POLICIES = 'policies';
